<template>
  <review-member-assignment-setting
    label="Restrict Conflict Resolution"
    description="Only specified reviewers can resolve conflicts"
    popup-title="Conflict Resolvers"
    :review="review"
    :permission="permission"
    :disabled="disabled"
    v-on="$listeners"
  />
</template>

<script>
import ReviewMemberAssignmentSetting from './ReviewMemberAssignmentSetting';
import { Review } from '@/models';
import { ReviewStage, ReviewMemberPermission } from '@/enums';

const STAGE_TO_PERMISSION = {
  [ReviewStage.SCREENING]:
    ReviewMemberPermission.RESOLVE_SCREENING_CONFLICT,
  [ReviewStage.FULL_TEXT_REVIEW]:
    ReviewMemberPermission.RESOLVE_FULL_TEXT_REVIEW_CONFLICT,
  [ReviewStage.DATA_EXTRACTION]:
    ReviewMemberPermission.RESOLVE_DATA_EXTRACTION_CONFLICT,
};

export default {
  name: 'ConsensusConflictResolversSetting',
  components: { ReviewMemberAssignmentSetting },
  props: {
    review: {
      type: Review,
      required: true,
    },
    stage: {
      type: String,
      required: true,
      validator: (field) =>
        Object.values(ReviewStage).includes(field),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['assign-permission', 'unassign-permission', 'unassign-all'],
  computed: {
    permission() {
      return STAGE_TO_PERMISSION[this.stage];
    },
  },
};
</script>
